import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
    'use strict';

    angular
        .module('staticHtmlPageControllers')
        .factory('staticHtmlPageService', service);

    service.$inject = ['$http', '$q'];

    function service($http, $q) {

        var service = {
            getPage: getPage
        };
        return service;

        ////////////

        function getPage(page) {
            return $http
                .get(environment.apiUrl + '/Pilot/api/Page/' + page, {})
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();
